import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import {
  selectAllBranches,
  useGetBranchListOnMount,
} from '@user/store/branches'
import { SelectItem } from '../typings'

export function useBranches() {
  const status = useGetBranchListOnMount()

  const loading = status === 'pending'

  const branches = useSelector(selectAllBranches)

  const formattedBranches = useMemo<SelectItem[]>(
    () => branches.map((b) => ({ label: b.name, value: b.id })),
    [branches],
  )

  return [loading, formattedBranches] as const
}
